import { IonContent, IonIcon, IonPage } from "@ionic/react";
import {
  bookmarkOutline,
  carOutline,
  cartOutline,
  chevronForward,
  flagOutline,
  helpCircleOutline,
  lockClosedOutline,
  mailOpen,
  mailOpenOutline,
  mailOutline,
  notificationsOutline,
  peopleCircleOutline,
  peopleOutline,
  playCircleOutline,
  schoolOutline,
  sparklesOutline,
  videocamOutline,
} from "ionicons/icons";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Footer } from "../components/layout/Footer";
import { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { PiFilmSlate } from "react-icons/pi";
import Avatar from "../components/avatar/Avatar";

const MorePage = () => {
  const { t } = useTranslation();
  const { username, fname, lname, isAdmin, avatar } = useSelector(
    (state) => state.currentProfile.data,
  );

  const handleLoonAIClick = (e) => {
    e.preventDefault();
    toast("Coming soon… Under Development", {
      duration: 3000,
      position: "top-center",
      style: {
        background: "#333",
        color: "#fff",
      },
    });
  };
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonContent>
          <div className="fullscreen-menu">
            <Link
              to={`/profile/${username}`}
              className="fullscreen-menu__profile"
            >
              <div className="fullscreen-menu__profile-info">
                {/* <img
                  src={avatar || "/logo1.webp"}
                  alt={username}
                  className="fullscreen-menu__avatar"
                /> */}
                <Avatar
                  size="md"
                  username={username}
                  avatar={avatar}
                  isOfficial={isAdmin}
                />
                <div>
                  <div className="fullscreen-menu__username">
                    {fname} {lname}
                  </div>
                  <div className="fullscreen-menu__handle">@{username}</div>
                </div>
              </div>
              <IonIcon
                icon={chevronForward}
                className="fullscreen-menu__icon"
              />
            </Link>

            <div className="fullscreen-menu__links">
              <Link
                to="/alerts"
                // className={`${location.pathname === "/alerts" ? "active" : ""}`}
              >
                <IonIcon icon={notificationsOutline} />
                <span>{t("Alerts")}</span>
              </Link>
              <Link
                to="/messages"
                // className={`${
                //   location.pathname === "/messages" ? "active" : ""
                // }`}
              >
                <IonIcon icon={mailOutline} />
                {/* <Badge content={unread.total}> */}
                <span>{t("Messages")}</span>
                {/* </Badge> */}
              </Link>
              <Link
                to="/bookmarks"
                // className={`${
                //   location.pathname === "/bookmarks" ? "active" : ""
                // }`}
              >
                <IonIcon icon={bookmarkOutline} />
                <span>{t("Bookmarks")}</span>
              </Link>

              <Link
                to="/study/study"
                // className={`${
                //   location.pathname === "/friends" ? "active" : ""
                // }`}
              >
                <IonIcon icon={schoolOutline} />
                <span>{t("mobileFooter.study")}</span>
              </Link>
              <Link
                to="/videos"
                // className={`${location.pathname === "/videos" ? "active" : ""}`}
              >
                {/* <IonIcon icon={playCircleOutline} /> */}
                <PiFilmSlate />
                <span>{t("videos")}</span>
              </Link>

              <Link
                to="/market"
                // className={`${location.pathname === "/market" ? "active" : ""}`}
              >
                <IonIcon icon={cartOutline} />
                <span>{t("Local Market")}</span>
              </Link>

              <Link
                to="/ride"
                // className={`${location.pathname === "/ride" ? "active" : ""}`}
              >
                <IonIcon icon={carOutline} />
                <span>{t("ride")}</span>
              </Link>

              <Link
                to="/loonlock"
                // className={`${
                //   location.pathname === "/loonlock" ? "active" : ""
                // }`}
              >
                <IonIcon icon={lockClosedOutline} />
                <span>LoonLock</span>
              </Link>

              {/* <Link to="/email">
                <IonIcon icon={mailOpenOutline} />
                <span>Email</span>
              </Link> */}
              {/* <Link to="/ai" onClick={handleLoonAIClick}>
              <IonIcon icon={sparklesOutline} />
              <span>LoonAI</span>
            </Link> */}
              {isAdmin && (
                <Fragment>
                  <Link to="/private/llg-7r0xw-b29">
                    <IonIcon icon={videocamOutline} />
                    <span>LoonVid</span>
                  </Link>
                  <Link to="/reports">
                    <IonIcon icon={flagOutline} />
                    <span>Reports</span>
                  </Link>
                  <Link to="/requests">
                    <IonIcon icon={helpCircleOutline} />
                    <span>Requests</span>
                  </Link>
                </Fragment>
              )}
            </div>

            <Footer />
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default MorePage;
